import { useEffect } from 'react';
import { useAuth } from '../context/AuthProvider';
import { restoreNativeNotifications } from '../utils/nativeNotifications';

/** App On Admin: đã đăng nhập + đã cho phép thông báo thì gắn máy này vào tài khoản (mỗi lần mở app). */
export default function NativeNotifications() {
  const { user } = useAuth();
  const userId = user?.id;
  useEffect(() => {
    if (!userId) return undefined;
    const retry = () => {
      restoreNativeNotifications().catch(() => {});
    };
    retry();
    window.addEventListener('online', retry);
    return () => window.removeEventListener('online', retry);
  }, [userId]);
  return null;
}
